import "./assets/js/nav-pills.js";
import "./assets/scss/medical-hospital.scss";

export default {
  // eslint-disable-next-line prettier/prettier
  install() {}
};
